import { render, staticRenderFns } from "./TypeTel.vue?vue&type=template&id=1d0c6520"
import script from "./TypeTel.vue?vue&type=script&lang=js"
export * from "./TypeTel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports